export const environment = {
  production: true,
  defaultauth: 'fakebackend',
 //urlapi: 'http://localhost:8080/',
 // urlapilogin: 'http://localhost:4200/dashboard',
 urlapi: 'https://www.websunia089.it/',
 urlapilogin: 'https://www.websunia089.it',
 //urlapi: 'http://194.124.75.74:8080/',
 //urlapilogin: 'http://194.124.75.74:4200/dashboard',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};
